// Partner companies data
export const partners = [
    {
        id: 'amtrust',
        name: 'AmTrust Medici',
        category: 'RC Professionale',
        specialization: 'Medical Malpractice',
        description: 'Leader mondiale nella copertura RC Professionale per medici e strutture sanitarie',
        logo: '/partners/amtrust-logo.svg',
        website: 'https://www.amtrustinternational.com',
        products: ['RC Professionale', 'Colpa Medica', 'Massimali Elevati'],
    },
    {
        id: 'lloyds',
        name: "Lloyd's",
        category: 'RC Professionale',
        specialization: 'Medical Malpractice',
        description: 'Mercato assicurativo più antico e prestigioso al mondo per rischi complessi',
        logo: '/partners/lloyds-logo.svg',
        website: 'https://www.lloyds.com',
        products: ['RC Professionale', 'Rischi Complessi', 'Coperture Internazionali'],
    },
    {
        id: 'tutela-legale',
        name: 'Tutela Legale SPA',
        category: 'Tutela Legale',
        specialization: 'Legal Protection',
        description: 'Specialisti nella difesa legale penale e civile per professionisti sanitari',
        logo: '/partners/tutela-legale-logo.svg',
        website: 'https://www.tutelalegale.it',
        products: ['Difesa Penale', 'Difesa Civile', 'Assistenza Legale 24/7'],
    },
    {
        id: 'generali',
        name: 'Generali',
        category: 'Vita & Infortuni',
        specialization: 'Life & Accident Insurance',
        description: 'Gruppo assicurativo leader in Europa per protezione della persona',
        logo: '/partners/generali-logo.svg',
        website: 'https://www.generali.it',
        products: ['Vita', 'Infortuni', 'Invalidità Permanente', 'Diaria'],
    },
    {
        id: 'metlife',
        name: 'MetLife',
        category: 'Vita & Infortuni',
        specialization: 'Life Insurance',
        description: 'Leader globale nelle soluzioni di protezione vita e risparmio',
        logo: '/partners/metlife-logo.svg',
        website: 'https://www.metlife.it',
        products: ['Vita', 'Protezione Famiglia', 'Risparmio'],
    },
    {
        id: 'itas-mutua',
        name: 'Itas Mutua',
        category: 'Vita Privata',
        specialization: 'Personal Protection',
        description: 'Compagnia mutua italiana specializzata in protezione patrimonio',
        logo: '/partners/itas-logo.svg',
        website: 'https://www.gruppoitas.it',
        products: ['Protezione Capofamiglia', 'Patrimonio', 'Casa'],
    },
    {
        id: 'reale-mutua',
        name: 'Reale Mutua',
        category: 'Vita Privata',
        specialization: 'Personal & Property Insurance',
        description: 'Prima compagnia assicuratrice italiana in forma di mutua',
        logo: '/partners/reale-mutua-logo.svg',
        website: 'https://www.realemutua.it',
        products: ['Protezione Famiglia', 'Auto', 'Casa', 'Risparmio'],
    },
];

// Get partners by category
export const getPartnersByCategory = (category) => {
    return partners.filter(partner => partner.category === category);
};

// Get partner by ID
export const getPartnerById = (id) => {
    return partners.find(partner => partner.id === id);
};

// Categories
export const categories = [
    'RC Professionale',
    'Vita & Infortuni',
    'Tutela Legale',
    'Vita Privata',
];
